import React from 'react';
import App from './App';
import './App.css';
import { Authenticator } from 'aws-amplify-react'; 
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

// your Cognito Hosted UI configuration
const oauth = {
	domain: process.env.REACT_APP_COGNITO_DOMAIN,
	scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
	redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT,
	redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT,
	responseType: 'code' // or token
};

awsconfig.aws_appsync_graphqlEndpoint = process.env.REACT_APP_GRAPHQL;

const config = Object.assign({}, awsconfig, {Auth: {
	oauth,
	userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
	userPoolId: process.env.REACT_APP_USER_POOL_ID,
	identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
	identityPoolRegion: 'us-east-1'
},
	API: {
		endpoints: [
			{
				name: 'IntvAPI',
				endpoint: 'https://' + process.env.REACT_APP_API_DOMAIN + '/'
			}
		]
	}
})

Amplify.configure(config)

const AppWithAuth = () => {
    return (
        <Authenticator amplifyConfig={config} hideDefault={true}>
            <App />
        </Authenticator>
    )
}

export default AppWithAuth;